import { DateTime, Duration } from 'luxon';
import { DailyHours, Location, LocationConfiguration, TimeInterval } from './location';

export namespace LocationParsers {
  export class LocationJson {
    id!: number;
    name!: string;
    phone?: string;
    timezone!: string;
    minimumLeadTime!: string;
    maximumLeadTime!: string;
    defaultLeadTime!: string;
    defaultRentalDuration!: string;
    checkAvailability!: boolean;
    showRentalTimeSelect!: boolean;
    hoursOfOperation!: DailyHours[];
    showRentalPrice!: boolean;
    showUnitsAvailable!: boolean;
    rentalTimeSlots!: TimeInterval[];
    disabledDates!: string[];
    currency!: string;
    allowNoPayment!: boolean;
    isActive!: boolean;
    isDefault!: boolean;
    isOffline!: boolean;
    totalProducts!: number;
    allowStripeTerminal!: boolean;
    address!: {
      address1: string;
      address2: string;
      city: string;
      state: string;
      stateCode: string;
      zip: string;
      country: string;
    };
    autoApproveAdminOrders!: boolean;
    autoCustomerAdminOrders!: boolean;
    allowDeliverySelection!: boolean;
  }

  export function toLocation(input: LocationJson): Location {
    return {
      rentalTimeSlots: input.rentalTimeSlots,
      disabledDates: input.disabledDates.map((d) => DateTime.fromISO(d, { zone: input.timezone }).startOf('day')),
      showRentalPrice: input.showRentalPrice,
      showUnitsAvailable: input.showUnitsAvailable,
      id: input.id,
      name: input.name,
      phone: input.phone,
      timezone: input.timezone,
      minimumLeadTime: Duration.fromISO(input.minimumLeadTime),
      maximumLeadTime: Duration.fromISO(input.maximumLeadTime),
      defaultLeadTime: Duration.fromISO(input.defaultLeadTime),
      defaultRentalDuration: Duration.fromISO(input.defaultRentalDuration),
      checkAvailability: input.checkAvailability,
      showRentalTimeSelect: input.showRentalTimeSelect,
      hoursOfOperation: input.hoursOfOperation,
      currency: input.currency,
      allowNoPayment: input.allowNoPayment,
      isActive: input.isActive,
      isDefault: input.isDefault,
      isOffline: input.isOffline,
      totalProducts: input.totalProducts,
      allowStripeTerminal: input.allowStripeTerminal,
      address: input.address,
      autoApproveAdminOrders: input.autoApproveAdminOrders,
      autoCustomerAdminOrders: input.autoCustomerAdminOrders,
      allowDeliverySelection: input.allowDeliverySelection,
    };
  }

  export class LocationConfigurationJson {
    variable!: string;
    value!: string;
    locationId!: number;
  }

  export function toLocationConfiguration(input: LocationConfigurationJson): LocationConfiguration {
    return {
      variable: input.variable,
      value: input.value,
      locationId: input.locationId,
    };
  }
}
